(function () {
  function hideSaleBadges(root) {
    (root || document).querySelectorAll('.badge').forEach(function (badge) {
      if (badge.textContent.trim().toLowerCase().startsWith('promotion')) {
        (badge.closest('.card__badge') || badge).style.display = 'none';
      }
    });
  }

  function start() {
    hideSaleBadges(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) hideSaleBadges(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();